import { Subscription } from '@weblite/ts-action/subscription'
import { createStorage } from '../lib/storage'

export const [subscriptionsStorage, subscriptionsReducer] = createStorage<
  Subscription
>('subscriptions')
